import FieldConfig from "../../proto/field-config"
import FieldMultiselect from "../multiselect/multiselect"
import {GROUP_INFO} from "../../../gd/const/fields/field2-groups"
import FieldTags_AutomationActionForm from "./render/automation-action-form"
import mapTag from "../../import/normalize/map-tag"
import ImportFromCSVModule from "../../../gd-modules/import-from-csv/import-from-csv-module"
import FieldTags_PopoverMenu from "./components/popover/popover-menu"
import FieldTag_Pill from "./components/pill"
import FieldTags_PopoverMenuMore from "./components/popover/more"
import FieldTags_Editable from "./render/editable/editable"
import {ProjectSystemType} from "../../../model2/project/types"
import ProjectSession from "../../../model2/project/project-session"
import FieldTag_ViewProperty from "./render/view-property";

// created for and currently used in automations only
// some modifications may be required to use it somewhere else if needed
export default class FieldTags extends FieldMultiselect {

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel          = "Tags"
        this.filterType         = null
        this.typeGroup          = GROUP_INFO
        this.typeDescription    = "Tags field"
        this.icon               = 'i5-tag'

        // special
        this.options            = []

        const tagsCollection = gd.session.projects.filterByCompany(gd.companyId).filterBySystemType(ProjectSystemType.TAG)
        _.map(tagsCollection.models, (tag:ProjectSession)=>{
            this.options!.push({
                value: tag.id,
                color: tag.color,
                label: tag.name
            })
        })

        this.classes.PopoverMenuScrollContainer     = ''

        this.renderComponents.automationActionForm  = FieldTags_AutomationActionForm
        this.renderComponents.editable              = FieldTags_Editable
        this.renderComponents.viewProperty          = FieldTag_ViewProperty
        // this.renderComponents.automationTriggerForm = FieldTags_AutomationTriggerForm

        this.components.PopoverMenu                 = FieldTags_PopoverMenu
        this.components.PopoverMenuMore             = FieldTags_PopoverMenuMore

        this.components.Pill                        = FieldTag_Pill
    }

    normalizeToCSVValue(model: any): any {
        const rawValue = super.normalizeToCSVValue(model)

        const getTagName = (tagId: string) => {
            const tag = gd.session.projects.get(tagId)
            return tag ? tag.name : ''
        }

        return _(rawValue).map(id=>getTagName(id)).compact().value().join(', ')
    }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        if (!value) return

        let errors: boolean  = false

        let tagNames: string[] = value.split(module.multiValueDelimiter)
        tagNames = _.map(tagNames, (tagName: string) => tagName.trim())

        const tags: string[] = []
        _.map(tagNames, (tagName: string): void => {
            const tagId = mapTag(tagName)
            if (tagId) {
                tags.push(tagId)
            } else {
                tags.push(tagName)
                errors = true
            }
        })

        if (errors) return

        return tags
    }
}
